export default "__VITE_ASSET__8wPPNJU5__"